import { Helmet } from "react-helmet";
import AnimalGrid from "components/animalgrid";
import BodyText from "components/bodytext";
import ContentBox from "components/contentbox";
import HeaderText from "components/headertext";
import PageGallery from "components/pagegallery";
import Image from "components/image";
// Images for animals in the collection grid

// Bulk image album
import archiveBrb2 from "img/brbs/BRB004a.jpg";
import archiveBrb4 from "img/brbs/20181229-scan405-3.jpg";
import collectionMeta from "content/collections/bullsnakes.json";
import { animalGridFromJson } from "hooks/useGallery";

const animalGridData = animalGridFromJson(collectionMeta);

const Bullsnakes = () => {
  return (
    <ContentBox>
      <Helmet>
        <title>{collectionMeta.commonName}</title>
        <meta
          name="description"
          content="See the Bullsnakes (Pituophis catenifer sayi)
            that are being kept here and learn more about their captive husbandry."
        />
        <link rel="canonical" href="https://www.gcreptiles.com/bullsnakes" />
      </Helmet>

      <HeaderText
        title={collectionMeta.commonName}
        subtitle={collectionMeta.scientificName}
      />

      <AnimalGrid data={animalGridData} />

      <BodyText>
        Bullsnakes
      </BodyText>

      <PageGallery slug="bullsnakes" maxWidth="900" />
    </ContentBox>
  );
};

export default Bullsnakes;
